<template>
    <div id="app">
        <Dialog v-if="displayDialog"/>
        <Header :img="getImg"/>
        <Feedback />
        <Popup/>
    </div>
</template>

<script>
  import A from './constants/actions';
  import AppConfig from './config/appConfig';
  import Dialog from './components/dialog/Dialog.vue';
  import DialogUtils from './utils/DialogUtils';
  import Header from './components/Header.vue';
  import Feedback from './components/feedback/Feedback.vue';
  import Popup from './components/popup/Popup.vue';
  import Paths from './constants/paths';

  export default {
    name: 'app',
    components: {
      Dialog,
      Header,
      Feedback,
      Popup,
    },
    computed: {
      displayDialog() {
        return this.$store.state.dialogStore.isOpen;
      },
    },
    methods: {
      getImg() {
        return process.env.BASE_URL + "logo/white_" + AppConfig.ui.branding + ".png";
      },
    }
  }

</script>
<style src="./app.css"></style>
